'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProcessingPage = require('../../../components/loaders/ProcessingPage');

var _ProcessingPage2 = _interopRequireDefault(_ProcessingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpdateCardProcessing = function UpdateCardProcessing(props) {
    return _react2.default.createElement(
        _ProcessingPage2.default,
        null,
        _react2.default.createElement(
            'h1',
            null,
            'Processing'
        ),
        _react2.default.createElement(
            'p',
            null,
            'This should only take a few seconds\u2026'
        ),
        _react2.default.createElement(
            'p',
            { className: 'disclaimer' },
            _react2.default.createElement(
                'a',
                { href: 'mailto:support@milanote.com' },
                'Report a problem'
            )
        )
    );
};

exports.default = UpdateCardProcessing;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/updateCard/UpdateCardProcessing.js
// module id = 2106
// module chunks = 0